import { useController } from 'react-hook-form';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';

import type { TelegramJoinGroupCardProps } from '@zealy/design-system';
import { Alert, Link, TelegramJoinGroupCard } from '@zealy/design-system';
import { GearLine } from '@zealy/icons';

import { withQuest } from '../Tasks.funcs';

const type = 'telegram' as const;
type Task = typeof type;

const Telegram = withQuest<TelegramJoinGroupCardProps, Task>(({ task }) => {
  const tSettings = useTranslations('settings.linked-accounts');
  const { subdomain } = useParams<{ subdomain: string }>();

  const { formState } = useController({
    name: task.id,
    defaultValue: {
      taskId: task.id,
      type,
    },
  });

  const error = formState.errors?.[task.id] as { message: string; type: string } | undefined;
  const isConnectionError = error?.type === 'TELEGRAM_ACCOUNT_NOT_LINKED';

  return (
    <div className="flex flex-col gap-200">
      <TelegramJoinGroupCard
        metadata={task.metadata}
        inviteLink={task.settings.inviteUrl}
        className="w-full"
        error={error && !isConnectionError ? error.message : undefined}
      />
      {error && isConnectionError && (
        <Alert
          variant="error"
          title="Connection Required"
          description={error.message}
          actions={
            <Link
              href={`/cw/${subdomain}/settings/linked-accounts`}
              leftIcon={<GearLine />}
              size="sm"
            >
              {tSettings('connect')} {tSettings('telegram.title')}
            </Link>
          }
        />
      )}
    </div>
  );
});

export default Telegram;
